import React from 'react';
import { Modal } from '@mantine/core';

export interface ImagePreviewModalProps {
    src: string;
    onClose: () => void;
}

function ImagePreviewModal({ src, onClose }: ImagePreviewModalProps) {
    return (
        <Modal opened onClose={onClose} size="auto" centered>
            <img src={src} alt="" data-testid="form-field-image-preview" style={{ display: 'block', maxWidth: '80vw', maxHeight: '80vh' }} />
        </Modal>
    );
}

export default ImagePreviewModal;
